<div class="d-flex flex-column gap-3">
  <div class="submission-grid">
    <app-submission-details-changes
      *ngIf="!previousDetails?.displayString; else previousDisplayString"
      label="Previous"
      i18n-label
      [changes]="previousDetails?.data"
      [borderColour]="'#C63221'"
      [backgroundColour]="'#FCEBEA'" />
    <ng-template #previousDisplayString>
      <div class="display-string-card previous">
        <div class="label-sm" i18n>Previous</div>
        <div class="display-string" i18n>{{ previousDetails.displayString }}</div>
      </div>
    </ng-template>
    <app-submission-details-changes
      *ngIf="!newDetails?.displayString; else newDisplayString"
      label="New"
      i18n-label
      [changes]="newDetails?.data"
      [borderColour]="'#13856B'"
      [backgroundColour]="'#E8F3F1'" />
    <ng-template #newDisplayString>
      <div class="display-string-card new">
        <div class="label-sm" i18n>New</div>
        <div class="display-string" i18n>{{ newDetails.displayString }}</div>
      </div>
    </ng-template>
  </div>
</div>
